<div class="results-list">
  <ng-container *ngFor="let app of apps">
    <mat-card
      *ngIf="showRemoveAction; else resultCard"
      appearance="outlined"
      class="related-app"
    >
      <mat-card-content class="related-app-content">
        <span class="related-app-content__info">
          <mat-icon
            *ngIf="getEnergySourceId(app) !== 'NA'"
            class="related-app-content__icon"
            [matTooltip]="getEnergySourceName(app)"
            [matTooltipPosition]="'right'"
            attr.aria-label="{{ getEnergySourceId(app) }} energy source icon"
            i18n-aria-label
            [svgIcon]="getEnergySourceId(app)"
          ></mat-icon>
          <div
            *ngIf="getEnergySourceId(app) === 'NA'"
            class="related-app-content__icon"
          ></div>
        </span>
        <div class="related-app-content__address">
          <div>{{ getAddedAddressLineOne(app) }}</div>
          <div>{{ getAddedAddressLineTwo(app) }}</div>
        </div>
        <div class="related-app-content__project-id">
          {{ getDisplayProjectId(app) }}
        </div>
        <div class="related-app-content__actions">
          <button mat-button disabled class="modal-close-button card-btn">
            {{ selectedActionLabel }}
          </button>
          <button
            mat-button
            class="modal-close-button card-btn"
            (click)="removeApp(app)"
          >
            {{ removeActionLabel }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <ng-template #resultCard>
      <mat-card
        appearance="outlined"
        class="item"
        [class.item--selected]="isAppSelected(app)"
        [class.item--disabled]="isAppDisabled(app)"
        [attr.aria-disabled]="isAppDisabled(app)"
      >
        <mat-card-content class="item-content">
          <div class="item-content__header">
            <span class="item-content__info">
              <mat-icon
                *ngIf="getEnergySourceId(app) !== 'NA'"
                class="item-content__icon"
                [matTooltip]="getEnergySourceName(app)"
                [matTooltipPosition]="'right'"
                attr.aria-label="{{ getEnergySourceId(app) }} energy source icon"
                i18n-aria-label
                [svgIcon]="getEnergySourceId(app)"
              ></mat-icon>
              <div
                *ngIf="getEnergySourceId(app) === 'NA'"
                class="item-content__icon"
              ></div>
              <h3 class="item-content__title">{{ app.typeName }}</h3>
            </span>
            <span class="item-content__status-tag">{{ app.statusName }}</span>
          </div>
          <div class="item-content__app-data">
            <div class="item-content__app-data__col">
              <div>{{ getOwnerName(app) }}</div>
              <div>{{ getAddress(app) }}</div>
              <div
                class="item-content__disabled-reason"
                *ngIf="getDisabledReason(app)"
              >
                {{ getDisabledReason(app) }}
              </div>
              <div>
                {{ app.applicationCapacity }}
                {{ app.applicationCapacity != null ? 'kW' : '' }}
              </div>
            </div>
            <div class="item-content__app-data__col">
              <div>{{ getDisplayCategoryName(app) }}</div>
              <div>{{ getDisplayProjectId(app) }}</div>
            </div>
          </div>
          <mat-card-actions align="end">
            <button
              mat-button
              class="modal-close-button card-btn"
              (click)="selectApp(app)"
              [disabled]="isAppDisabled(app)"
            >
              {{ isAppSelected(app) ? selectedActionLabel : actionLabel }}
            </button>
          </mat-card-actions>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </ng-container>
</div>
